<template>
	<div class="cm-table-wrapper">
		<div ref="bsTable" class="cm-table-layout">
			<div class="cm-table-scroll-wrapper">
				<!-- div: bs pointer-events: auto; 占位 -->
				<div class="cm-table-extra-box">
					<div class="cm-table-container">
						<div class="cm-table-thead">
							<div class="cm-table-tr">
								<div
									v-for="column in itemList"
									:key="column.prop"
									:style="composeColumnStyle(column)"
									class="c-table-th"
								>
									<div class="cell">{{ formatLabel(column) }}</div>
								</div>
							</div>
						</div>
						<div class="cm-table-tbody">
							<template v-if="dataList.length">
								<div v-for="(row, itemIdx) in dataList" :key="itemIdx" class="c-table-row">
									<div
										v-for="column in itemList"
										:key="column.prop"
										:style="composeColumnStyle(column)"
										class="c-table-column"
									>
										<div class="cell">
											<slot
												v-if="column.slot"
												:name="column.slot"
												:row="row"
												:rowIdx="itemIdx"
											></slot>
											<span v-else :class="composeCellClass(column)">{{
												formatCell(column, row)
											}}</span>
										</div>
									</div>
								</div>
							</template>
							<div v-else class="c-table-row">
								<div class="c-table-column">
									<div class="cell cell--empty">
										<span>{{ $t('enterprise.no-data') }}</span>
									</div>
								</div>
							</div>
						</div>
						<div ref="loadMoreTrigger" class="cm-table-footer">
							<div v-if="more" class="cell">{{ $t('enterprise.loading') }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BScroll from 'better-scroll';
import { formatDefault } from '@/utils/api';

export default {
	props: {
		itemList: {
			type: Array,
			default: () => []
		},
		dataList: {
			type: Array,
			default: () => []
		},
		more: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tableBScroll: null,
			observer: null,
			noMore: false,
			moreLoadingIng: false
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.initBS();
		});
	},
	beforeUnmount() {
		if (this.observer) {
			this.observer.unobserve(this.$refs.loadMoreTrigger);
		}
	},
	watch: {
		more: {
			handler(val) {
				if (val) {
					this.$nextTick(() => {
						this.setupIntersectionObserver();
					});
				}
			},
			immediate: true
		}
	},
	methods: {
		initBS() {
			this.tableBScroll = new BScroll(this.$refs.bsTable, {
				scrollX: true,
				scrollY: false,
				eventPassthrough: 'vertical',
				bounce: false,
				probeType: 3 // listening scroll event
			});
		},
		composeColumnStyle(column) {
			let style = {};
			if (column.width) {
				style['width'] = `${column.width / 100}rem`;
				style['flex'] = 'none';
			}
			if (column.align) {
				style['text-align'] = column.align;
			}
			return style;
		},
		composeCellClass(column) {
			let classname = '';
			if (column.barlow) {
				classname = 'font-table-barlow';
			}
			return classname;
		},
		formatCell(column, row) {
			return column.formatter ? column.formatter(row[column.prop]) : formatDefault(row[column.prop]);
		},
		formatLabel(column) {
			return typeof column.label === 'function' ? column.label() : column.label;
		},

		// 加载更多
		setupIntersectionObserver() {
			const _observer = new IntersectionObserver(
				entries => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							// 当元素进入视口时触发加载更多数据
							this.loadMoreData();
						}
					});
				},
				{ threshold: 0 }
			); // 可调整阈值以控制元素在视口中的位置比例

			// 开始观察指定的DOM元素
			if (this.$refs.loadMoreTrigger) {
				_observer.observe(this.$refs.loadMoreTrigger);
				this.observer = _observer;
			}
		},
		loadMoreData() {
			if (!this.more) return;
			if (this.moreLoadingIng) return;
			this.moreLoadingIng = true;
			this.$emit('loadMore', () => {
				this.moreLoadingIng = false;
			});
		}
	}
};
</script>

<style lang="less" scoped>
.cm-table-layout {
	overflow: hidden;
	white-space: nowrap;
}
.cm-table-scroll-wrapper {
	min-width: 100%;
	display: inline-flex;
}
.cm-table-extra-box {
	flex: 1;
	display: flex;
}
.cm-table-container {
	flex: 1;

	.cell {
		white-space: pre-wrap;
		color: #1d2129;
		 
		font-size: 14px;
		 
		font-weight: 400;
		line-height: 18px; /* 128.571% */

		&--empty {
			text-align: center;
		}
	}

	.cm-table-tr,
	.c-table-row {
		display: flex;
	}
	.c-table-th,
	.c-table-column {
		flex: 1;
	}

	.c-table-th,
	.c-table-column {
		&:not(:first-child) {
			text-align: right;
		}
	}

	.cm-table-thead {
		background: #eee;

		.cell {
			padding: 7px 10px;
			font-weight: 500;
		}
	}
	.cm-table-tbody {
		.c-table-row {
			&:nth-child(odd) {
				background: #fff;
			}
			&:nth-child(even) {
				background: #f8f8f8;
			}
		}

		.c-table-column {
			// 内容区垂直居中
			display: flex;
			align-items: center;
		}
		.cell {
			flex: 1;
			padding: 10px;

		}
	}
	.cm-table-footer {
		text-align: center;

		.cell {
			padding: 10px;
		}
	}
}
</style>
